import App from "./App.svelte";
import online from "./configs/status.js";
import { mount } from "svelte";
import { baseLocale, locales, setLocale } from "./paraglide/runtime.js";

const localePreferenceKey = "cc-locale";
const supportedLocales = new Set(locales);

function normalizeLocale(value) {
	if (typeof value !== "string") {
		return "";
	}

	return value.trim().replace(/_/g, "-");
}

function mapLocaleCandidate(value) {
	const normalized = normalizeLocale(value);
	if (!normalized) {
		return "";
	}

	if (supportedLocales.has(normalized)) {
		return normalized;
	}

	const lower = normalized.toLowerCase();
	if (lower.startsWith("zh")) {
		return "zh-CN";
	}

	if (lower.startsWith("pt")) {
		return "pt-PT";
	}

	const baseLanguage = normalized.split("-")[0];
	if (supportedLocales.has(baseLanguage)) {
		return baseLanguage;
	}

	return "";
}

function detectPreferredLocale() {
	const languageCandidates = [];

	if (typeof navigator !== "undefined") {
		if (Array.isArray(navigator.languages)) {
			languageCandidates.push(...navigator.languages);
		}

		if (navigator.language) {
			languageCandidates.push(navigator.language);
		}
	}

	for (const candidate of languageCandidates) {
		const mappedLocale = mapLocaleCandidate(candidate);
		if (mappedLocale && supportedLocales.has(mappedLocale)) {
			return mappedLocale;
		}
	}

	return baseLocale;
}

const savedLocaleRaw = localStorage.getItem(localePreferenceKey);
const savedLocale = mapLocaleCandidate(savedLocaleRaw);
const hasSavedPreference = Boolean(savedLocaleRaw) && Boolean(savedLocale);
const detectedLocale = detectPreferredLocale();
const initialLocale = hasSavedPreference ? savedLocale : detectedLocale;

if (!hasSavedPreference) {
	localStorage.setItem(localePreferenceKey, initialLocale);
}

setLocale(initialLocale, { reload: false });

document.body.innerHTML = "";

const app = mount(App, {
	target: document.body,
});

export default app;
